<template>
  <div lass="t-index">
    <div class="home-header">
      <div class="header-main content">
        <img src="../../static/img/index/headtitle.png">
        <div class="header-search">
          <div class="input-text">
            <input type="text" class="form-control dropdown-toggle" data-toggle="dropdown"
                   placeholder="请输入您要搜索的内容"
                   aria-expanded="false" v-model="searchKey" @keyup.enter="openSearch">
            <span class="input-group-btn">
              <button class="btn btn-warning" type="submit" @click="openSearch">搜 索</button>
            </span>
          </div>
          <div class="hotsearch"
               @click="openNewPag('https://www.gdzwfw.gov.cn/portal/v2/guide/11440106MB2C79403T4440705001000')">
          </div>
        </div>
      </div>

    </div>
    <div class="banner-con">
      <div class="swiper banner-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="banner-img">
              <img src="../../static/img/index/banner01.png">
            </div>
          </div>
          <div class="swiper-slide">
            <div class="banner-img">
              <img src="../../static/img/index/banner02.png">
            </div>
          </div>
          <div class="swiper-slide">
            <div class="banner-img">
              <img src="../../static/img/index/banner03.png">
            </div>
          </div>
          <div class="swiper-slide">
            <div class="banner-img">
              <img src="../../static/img/index/banner04.png">
            </div>
          </div>
        </div>
        <div class="swiper-button-next-img swiper-button-next4" style="margin-right: 120px"></div>
        <div class="swiper-button-prev-img swiper-button-prev4" style="margin-left: 120px"></div>
      </div>
    </div>
    <div class="content">
      <div class="Zntj ">
        <div class="Zntj-left">
          <div class="Zntj-title"><span>热门</span><span>事项</span><img src="../../static/img/global/zntj-hot.png"
                                                                         alt=""></div>
        </div>
        <div class="Zntj-right">
          <ul>
            <li><a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v3/guide-combo/11440106007508683Q444TC06127000"><img
              src="../../static/img/global/zntj-hot1.png">我要换领居民身份证</a></li>
            <li><a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/11440106007508683Q4440106043001"><img
              src="../../static/img/global/zntj-hot1.png">办理往来港澳通行证</a></li>
            <li><a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/11440106007508683Q4440106043008"><img
              src="../../static/img/global/zntj-hot1.png">办理往来港澳通行证个人游签注</a></li>
            <li><a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/1144010607844173874440125017023"><img
              src="../../static/img/global/zntj-hot1.png">合伙企业设立登记</a></li>
            <li><a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/1144010607844173874440125017049">内资分公司设立登记</a>
            </li>
            <li><a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/1144010607844173874440102008001">非学历教育机构设立</a>
            </li>
            <li><a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/1144010607844173874440125017022">外商投资的公司分公司设立登记</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="main g-main">
      <div class="outcont" id="yytxq">
        <div class="container service">
          <div class="title title01"></div>
          <div class="tab-one">
            <div class="tab-item active">
              <div class="tab-item-img">
                <img src="../../static/img/index/person.png" alt="">
              </div>
              <div class="tab-item-text">
                个人事项
              </div>
              <div class="active-line">
                <div class="triangle"></div>
              </div>
            </div>
            <div class="tab-item">
              <div class="tab-item-img">
                <img src="../../static/img/index/legal.png" alt="">
              </div>
              <div class="tab-item-text">
                法人事项
              </div>
              <div class="active-line">
                <div class="triangle"></div>
              </div>
            </div>
          </div>
          <div class="line"></div>
          <div class="one-cont">
            <div class="cont-theme cont1">
              <div class="subject-list">
                <div class="line"></div>
                <div class="list">
                  <div :class="[index == 0 ? 'item active' : 'item']" v-for="(item, index) in gerenTheme.themeList">
                    <div class="title"><img :src="item.icon">{{ item.name }}</div>
                    <div :class="[index == 0 ? 'index index-active' : 'index index-normal']">{{ index + 1 }}</div>
                  </div>
                </div>
              </div>
              <div class="two-cont">
                <div class="cont service-cont" v-for="(item1, index1) in gerenTheme.themeList">
                  <div class="service-list">
                    <div class="swiper list-swiper">
                      <div class="swiper-wrapper">
                        <div class="swiper-slide">
                          <div class="service-table">
                            <div class="service-body">
                              <div class="service-item" v-for="(item2, index2) in item1.itemList.slice(pageSize*(currentPage_gr[index1]-1),pageSize*(currentPage_gr[index1]))">
                                <div>
                                  <a target="_blank"
                                     :href="item2.itemUrl">{{ index2 + 1 }}&nbsp;&nbsp;&nbsp;&nbsp;{{item2.itemName }}</a>
                                </div>
                                <div :class="[item2.lbsjdUrl ? 'lbsjd-active' : 'lbsjd-normal']" @click="openNewPage(item2.lbsjdUrl)">"路标式"解读</div>
                                <div>
                                  <a target="_blank" :href="item2.bsznUrl">办事指南</a>
                                  <el-popover
                                    placement="bottom"
                                    trigger="hover"
                                    :visible-arrow="false"
                                    :popper-options="{ boundariesElement: 'body', removeOnDestroy: true }" v-if="item2.ermIcon">
                                    <div class="service-item-ewm">
                                      <img :src="item2.ermIcon">
                                      <div>使用微信扫码登录</div>
                                    </div>
                                    <el-button type="text" slot="reference">手机办理</el-button>
                                  </el-popover>
                                  <a target="_blank" :href="item2.sjblUrl" v-else>手机办理</a>
                                  <a target="_blank" :href="item2.zxblUrl">在线办理</a>
                                </div>
                              </div>
                              <el-pagination
                                v-if="item1.itemList.length>pageSize"
                                prev-text="上一页"
                                next-text="下一页"
                                :total="item1.itemList.length"
                                :current-page="currentPage_gr[index1]"
                                :page-size="pageSize"
                                layout="prev, pager, next"
                                @current-change="handlePageChange($event,index1,'gr')"
                              ></el-pagination>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="swiper-pagination swiper-pagination1"></div>
                    </div>
                  </div>
                  <div class="onedo" v-if="item1.chainItemList">
                    <div class="onedotitle">本阶段相关“一件事”套餐服务</div>
                    <div class="onedoline"></div>
                    <div class="swiper list-swiper">
                      <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item2, index2) in item1.chainItemList">
                          <div class="onedo-list">
                            <div class="onedo-item"
                                 v-for="(item3, index3) in item2">
                              <div class="icon">
                                <img :src="item3.icon" alt="">
                              </div>
                              <div class="text">
                                <span>{{item3.itemName}}</span><br/>
                                <span>{{item3.itemDesc}}</span>
                              </div>
                              <div class="onedo-btn-group">
                                <div class="onedo-btn onedo-btn-active"
                                     @click="openNewPage(item3.zxblUrl)">在线办理</div>
                                <div class="onedo-btn onedo-btn-active"
                                     @click="openNewPage(item3.bsznUrl)">办事指南</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="swiper-pagination swiper-pagination1"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="cont-theme cont2" style="display: none;">
              <div class="subject-list">
                <div class="line"></div>
                <div class="list" style="gap: 128px">
                  <div :class="[index == 0 ? 'item active' : 'item']" v-for="(item, index) in farenTheme.themeList">
                    <div class="title"><img :src="item.icon">{{ item.name }}</div>
                    <div :class="[index == 0 ? 'index index-active' : 'index index-normal']">{{ index + 1 }}</div>
                  </div>
                </div>
              </div>
              <div class="two-cont1">
                <!--                企业开办-->
                <div class="cont service-cont" v-for="(item1, index1) in farenTheme.themeList">
                  <div class="list1" v-if="item1.itemList">
                    <div class="service-list">
                      <div class="swiper list-swiper">
                        <div class="swiper-wrapper">
                          <div class="swiper-slide">
                            <div class="service-table">
                              <div class="service-body">
                                <div class="service-item" v-for="(item2, index2) in item1.itemList.slice(pageSize*(currentPage_fr[index1]-1),pageSize*(currentPage_fr[index1]))">
                                  <div>
                                    <a target="_blank"
                                       :href="item2.itemUrl">{{ index2 + 1 }}&nbsp;&nbsp;&nbsp;&nbsp;{{item2.itemName }}</a>
                                  </div>
                                  <div :class="[item2.lbsjdUrl ? 'lbsjd-active' : 'lbsjd-normal']" @click="openNewPage(item2.lbsjdUrl)">"路标式"解读</div>
                                  <div>
                                    <a target="_blank" :href="item2.bsznUrl">办事指南</a>
                                    <el-popover
                                      placement="bottom"
                                      trigger="hover"
                                      :visible-arrow="false"
                                      :popper-options="{ boundariesElement: 'body', removeOnDestroy: true }" v-if="item2.ermIcon">
                                      <div class="service-item-ewm">
                                        <img :src="item2.ermIcon">
                                        <div>使用微信扫码登录</div>
                                      </div>
                                      <el-button type="text" size="mini" slot="reference">手机办理</el-button>
                                    </el-popover>
                                    <a target="_blank" :href="item2.sjblUrl" v-else>手机办理</a>
                                    <a target="_blank" :href="item2.zxblUrl">在线办理</a>
                                  </div>
                                </div>
                                <el-pagination
                                  v-if="item1.itemList.length>pageSize"
                                  prev-text="上一页"
                                  next-text="下一页"
                                  :total="item1.itemList.length"
                                  :current-page="currentPage_fr[index1]"
                                  :page-size="pageSize"
                                  layout="prev, pager, next"
                                  @current-change="handlePageChange($event,index1,'fr')"
                                ></el-pagination>
                              </div>

                            </div>
                          </div>
                        </div>
                        <div class="swiper-pagination swiper-pagination1"></div>
                      </div>
                    </div>
                    <div class="onedo" v-if="item1.chainItemList">
                      <div class="onedotitle">本阶段相关“一件事”套餐服务</div>
                      <div class="onedoline"></div>
                      <div class="swiper list-swiper">
                        <div class="swiper-wrapper">
                          <div class="swiper-slide"  v-for="(item2, index2) in item1.chainItemList">
                            <div class="onedo-list">
                              <div class="onedo-item"
                                   v-for="(item3, index3) in item2">
                                <div class="icon">
                                  <img :src="item3.icon" alt="">
                                </div>
                                <div class="text">
                                  <span>{{item3.itemName}}</span><br/>
                                  <span>{{item3.itemDesc}}</span>
                                </div>
                                <div class="onedo-btn-group">
                                  <div class="onedo-btn onedo-btn-active"
                                       @click="openNewPage(item3.zxblUrl)">在线办理</div>
                                  <div class="onedo-btn onedo-btn-active"
                                       @click="openNewPage(item3.bsznUrl)">办事指南</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="swiper-pagination swiper-pagination1"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--      特色-->
      <div class="outcont feature" id="tsq">
        <div class="container">
          <div class="title04"></div>
          <div class="swiper tese-swiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="feature-item" @click="zhengceduixian">
                  <div class="icon">
                    <img src="../../static/img/index/tese-img1.png">
                  </div>
                  <div class="text">
                    <span>政策兑现平台</span><br/>
                    <span>政策兑现一站式申报服务平台</span>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="feature-item" @click="openDawan">
                  <div class="icon">
                    <img src="../../static/img/index/tese-yga.png">
                  </div>
                  <div class="text">
                    <span>粤港澳大湾区服务专区</span><br/>
                    <span>大湾区办事指南解读</span>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="feature-item" @click="qiyeyiwangtong">
                  <div class="icon">
                    <img src="../../static/img/index/tese-img3.png">
                  </div>
                  <div class="text">
                    <span>广州市开办企业一网通</span><br/>
                    <span>开办企业一网通</span>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="feature-item" @click="yizhaotongxing">
                  <div class="icon">
                    <img src="../../static/img/index/tese-img4.png">
                  </div>
                  <div class="text">
                    <span>一照通行联办</span><br/>
                    <span>一照通行联办</span>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="feature-item" @click="gongchengjiansheshenpi">
                  <div class="icon">
                    <img src="../../static/img/index/tese-img5.png">
                  </div>
                  <div class="text">
                            <span>广州市工程建设项目联合
                                审批平台</span><br/>
                    <span>联合申报、协同审批</span>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="feature-item" @click="yjswoyaokanOnclick">
                  <div class="icon">
                    <img src="../../static/img/index/tese-img6.jpg">
                  </div>
                  <div class="text">
                    <span>一件事我要看</span><br/>
                    <span>一窗受理、一张表单、一次办理，为企业提供主题式、套餐式集成服务。</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-button-next" style="right: -50px; margin-top: 50px"></div>
          <div class="swiper-button-prev" style="left: -50px; margin-top: 50px"></div>
        </div>
      </div>
    </div>
  </div>

</template>
<!-- Global  -->
<script src="../../static/js/global.js"></script>
<script src="../../static/js/common.js"></script>
<!-- Page -->
<script src="../../static/js/index.js"></script>

<style>
@import '../../static/css/index.css';
@import '../../static/css/bootstrap.min.css';
@import '../../static/css/global.css';
@import '../../static/css/common.css';
@import '../../static/js/vendor/swiper/swiper-bundle.min.css';

</style>
<script>
import 'echarts/lib/component/polar'
import 'echarts/lib/chart/line'
import VChart, {THEME_KEY} from 'vue-echarts';
import themeJson from "../../static/js/theme.json"

export default {
  components: {VChart},
  data() {
    return {
      total: themeJson.gerenTheme.themeList.length,
      currentPage_gr: [],
      currentPage_fr: [],
      pageSize: 10,
      searchKey: "",
      gerenTheme: themeJson.gerenTheme,
      farenTheme: themeJson.farenTheme,
    }
  },

  mounted() {
    this.currentPage_gr =  new Array(this.gerenTheme.themeList.length);
    for(var i=0;i<this.gerenTheme.themeList.length;i++){
      this.currentPage_gr[i] = 1;
    }
    this.currentPage_fr =  new Array(this.farenTheme.themeList.length);
    for(var i=0;i<this.farenTheme.themeList.length;i++){
      this.currentPage_fr[i] = 1;
    }
  },
  methods: {
    handlePageChange(pageNum,currentThemeIndex,type) {
      if (type ==="gr") {
        this.currentPage_gr.splice(currentThemeIndex,1,pageNum)
        // this.currentPage[currentThemeIndex] = pageNum-1;
        console.log("pageNum ="+(pageNum)+ " currentThemeIndex "+currentThemeIndex + "  this.currentPage_gr[currentThemeIndex] ="+this.currentPage_gr)
      } else {
        this.currentPage_fr.splice(currentThemeIndex,1,pageNum)
        // this.currentPage[currentThemeIndex] = pageNum-1;
        console.log("pageNum ="+(pageNum)+ " currentThemeIndex "+currentThemeIndex + "  this.currentPage_fr[currentThemeIndex] ="+this.currentPage_fr)
      }
    },

    onedo(url) {
      window.open(url)
    },

    openSearch() {
      var key = this.searchKey
      console.log(key)
      if (key == null || key == "") {
        return
      }
      let routeData = this.$router.resolve({
        name: 'search',
        query: {
          key: key
        }
      });
      window.open(routeData.href, '_blank')
    },

    openMultiple() {
      let routeData = this.$router.resolve({
        name: 'multiple',
      });
      window.open(routeData.href, '_blank')
    },
    openDawan() {
      let routeData = this.$router.resolve({
        name: 'dawan',
      });
      window.open(routeData.href, '_blank')
    },
    openNewPage(url) {
      if (url) {
        window.open(url)
      }
    },
    zhinengzixunOnclick() {
      window.open("http://www.thnet.gov.cn/znzx.html")
    },
    zhengwuyunchuangOnclick() {
      window.open("https://thzwb.thnet.gov.cn/web/terminal/static/busiPage/xiaowu/validphone.html")
    },
    yjswoyaokanOnclick() {
      window.open("http://thzwb.thnet.gov.cn/icity/icity/chain/index")
    },
    dawanquOnclick() {

    },
    zhengceduixian() {
      window.open("http://thzwb.thnet.gov.cn/policy/#/home")
    },
    zhengcejisuanqi() {
      window.open("http://thzwb.thnet.gov.cn/policy/#/calculator")
    },
    qiyeyiwangtong() {
      window.open("http://scjgj.gz.gov.cn/ywt/#/")
    },
    yizhaotongxing() {
      window.open("https://zwfw.gzonline.gov.cn/wsbs-yztx/list")
    },
    gongchengjiansheshenpi() {
      window.open("http://lhsp.gzonline.gov.cn/")
    },
  }
}
</script>
<style scoped>
.el-pagination {
  padding: 20px 0;
}
</style>



// WEBPACK FOOTER //
// Home.vue?73d27628